import { getPrefersReducedMotion as e } from "./use-prefers-reduced-motion.js";
const n = (o) => {
  const t = o.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({ top: t, behavior: e() ? "auto" : "smooth" });
};
export {
  n as scrollElementIntoViewVertically
};
